import { api } from "@/lib/axios";

export interface Visit {
  _id: string;
  propertyId: string;
  buyerId: string;
  sellerId: string;
  date: string;
  timeSlot: string;
  status: "pending" | "confirmed" | "cancelled" | "completed";
  message?: string;
  createdAt: string;
}

export interface ScheduleVisitData {
  propertyId: string;
  date: string;
  timeSlot: string;
  message?: string;
}

export const getVisits = async (): Promise<Visit[]> => {
  const response = await api.get("/api/visits");
  return response.data;
};

export const getPropertyVisits = async (propertyId: string) => {
  const response = await api.get(`/api/visits/property/${propertyId}`);
  return response.data;
};

export const scheduleVisit = async (data: ScheduleVisitData): Promise<Visit> => {
  const response = await api.post("/api/visits", data);
  return response.data;
};

export const updateVisitStatus = async (visitId: string, status: Visit["status"]): Promise<Visit> => {
  const response = await api.patch(`/api/visits/${visitId}/status`, { status });
  return response.data;
};

export const cancelVisit = async (visitId: string): Promise<Visit> => {
  const response = await api.patch(`/api/visits/${visitId}/cancel`);
  return response.data;
};

export const deleteVisit = async (visitId: string): Promise<void> => {
  await api.delete(`/api/visits/${visitId}`);
}; 